import PropTypes from 'prop-types';
import React from 'react';

// The Work tracker's line icons. All 20×20 viewBoxes drawn in currentColor,
// so the button around each one decides the colour.
const svg = (size, extra) => ({
  width: size,
  height: size,
  viewBox: '0 0 20 20',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  ...extra,
});

export const ListIcon = () => (
  <svg {...svg(18)}>
    <path d="M7 5h10M7 10h10M7 15h10" />
    <circle cx="3.5" cy="5" r="1" fill="currentColor" stroke="none" />
    <circle cx="3.5" cy="10" r="1" fill="currentColor" stroke="none" />
    <circle cx="3.5" cy="15" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const CalendarIcon = () => (
  <svg {...svg(18)}>
    <rect x="2.5" y="4" width="15" height="13.5" rx="2" />
    <path d="M2.5 8.5h15M6.5 2v4M13.5 2v4" />
  </svg>
);

export const SearchIcon = ({ className }) => (
  <svg {...svg(16, { className })}>
    <circle cx="8.5" cy="8.5" r="5.5" />
    <path d="m13 13 4.5 4.5" />
  </svg>
);
SearchIcon.propTypes = { className: PropTypes.string };
SearchIcon.defaultProps = { className: undefined };

export const PencilIcon = () => (
  <svg {...svg(15)}>
    <path d="M13.5 3.5l3 3L7 16H4v-3z" />
  </svg>
);

export const PlusIcon = () => (
  <svg {...svg(15, { strokeWidth: 2.2 })}>
    <path d="M10 4v12M4 10h12" />
  </svg>
);

export const BubbleIcon = () => (
  <svg {...svg(15)}>
    <path d="M3 4.5h14v9H8l-4 3v-3H3z" />
  </svg>
);
